export const NAVIGATION_MAP = {

 ROLE_SUPERADMIN: [
	    { label: ".", path: "/superadmin/dashboard", icon: "home" },
	    { 
	      label: "Administration", 
	      icon: "shield",
	      children: [
	        { label: "Administrateurs", path: "/superadmin/admins", icon: "users" },
	      ]
	    },
	    { 
	      label: "Configuration", 
	      icon: "settings",
	      children: [
	        { label: "Moteurs", path: "/superadmin/config/moteurs", icon: "cpu" },
	        { label: "Modèle Licence", path: "/superadmin/config/licences", icon: "credit-card" },
			{ label: "Sauvegardes", path: "/superadmin/config/backup", icon: "server" },
	      ]
	    },
	    { 
	      label: "Monitoring", 
	      icon: "activity",
	      children: [
	        { label: "Système", path: "/superadmin/monitoring", icon: "server" },
	        { label: "Moteurs", path: "/superadmin/moteur/monitor", icon: "cpu" },
	        { label: "Logs d'Audit", path: "/superadmin/audit-logs", icon: "database" },
	      ]
	    },
	  ],
 
 ROLE_ADMIN: [
    { label: ". ", path: "/admin/dashboard", icon: "home" },
	{ label: "Gestion clients ", path: "/admin/clients", icon: "users" },
	{ 
		 label: " Gestion Formations", 
		 icon: "file",
		 children: [
		        { label: "Formation ", path: "/admin/formation", icon: "users" },
				{ label: "Build formation ",path: "/admin/buildjson", icon: "webhook" },
				{ label: "Build Form MEDIA",path: "/admin/buildjsonRich", icon: "webhook" },
		   ]
	},
	{
		 label: "Gestion Evaluation", 
		 icon: "activity",
		 children: [
			{ label: "Evaluation ", path: "/admin/evaluation", icon: "users" },
			{ label: "Build evaluation", path: "/admin/buildeval", icon: "activity" },			
			{ label: "Build EVAL Rich", path: "/admin/buildevalrich", icon: "activity" },
			]
	},
	
	{ 
		label: "Reporting ", 
		icon: "activity",
		children: [
			{ label: "Reporting Admin", path: "/admin/reportadmin", icon: "briefcase" },
			{ label: "* Reporting Etudiant ", path: "/admin/reportetudiant", icon: "users" },
			{ label: "* Reporting Formation ", path: "/admin/reportformation", icon: "activity" },	
			{ label: "* Reporting Evaluation ", path: "/admin/reportevaluation", icon: "activity" },	
			{ label: "* Reporting Client ", path: "/admin/reportclient", icon: "activity" },				
		]
	},
  ],
 
  ROLE_CLIENT: [
    { label: ".", path: "/client/dashboard", icon: "home" },
	{ 
		label: " Gestion Etudiant", 
		icon: "users",
		children: [
			{ label: "Etudiants ", path: "/client/etudiant", icon: "users" },
			{ label: "Inscriptions ", path: "/client/inscription", icon: "webhook" },
			{ label: "Postuler-Demander", path: "/client/formations/postdeman", icon: "book" }, 
		]
	},

	{ 
		label: " Gestion Evaluation", 
		icon: "briefcase",
		children: [
			{ label: "Evaluations ", path: "/client/evaluation",  icon: "webhook" },
			{ label: "Eval Enrichie ", path: "/client/evaluationrich",  icon: "webhook"},
		]
	},
	{ 
		label: " Gestion Corrections", 
		icon: "briefcase",
		children: [
			{ label: "Correction", path: "/client/correction", icon: "webhook" },
			{ label: "Resultats", path: "/client/resultat", icon: "activity" },
		]
	},
    { label: "Rapports", path: "/client/rapport", icon: "activity" },
  ],
  
  ROLE_ETUDIANT: [
    { label: "Acceuil", path: "/etudiant/dashboard",icon: "home" },
  ]
};